import { ButtonBack } from "components/buttons";
import { MprcContainer } from "components/MprcContainer";
import { MprcFormBarHeader } from "components/MprcFormBarHeader";
import { MprcPrompt } from "components/MprcPrompt";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";
import React, { useState } from "react";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    actions?: React.ReactNode[];
    recordChanged: boolean;
    reloadOnClose: boolean;
    onClose: (reload?: boolean) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Edição de Papéis de Segurança
 * @param props
 */
export const EditUserHeader: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////

    const { actions, recordChanged, reloadOnClose, onClose } = props;
    const [showLostChange, setShowLostChange] = useState<boolean>(false);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(props.recordChanged);

    ////////////////////////////////////////////////////////////////////////////

    const handleClose = () => {
        if (recordChanged) {
            setShowLostChange(true);
        }
        else {
            onClose(reloadOnClose);
        }
    };

    var headerItems: React.ReactNode[] = [<ButtonBack rounded size="large" variant="text" onClick={handleClose} />];
    if (actions)
        headerItems = [...headerItems, ...actions];

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer>
            <MprcFormBarHeader actions={headerItems} />

            <MprcPrompt
                open={showPrompt}
                onConfirm={confirmNavigation}
                onCancel={cancelNavigation} />

            <MprcPrompt
                open={showLostChange}
                onCancel={() => setShowLostChange(false)}
                onConfirm={onClose} />

        </MprcContainer>
    );
};
